import {DispatchFunction, ITenantLicense, IOrganizationLicenseInfo, IActiveFilter} from '@app/models';
import { GET_TENANT_LICENSE, GET_ORG_LICENSES, LICENSES_LOADING, ORG_LICENSE_COUNT } from '../constants';
import { Dispatch } from 'redux';
import { licenseAllocationService } from '@app/services';
import { AxiosResponse } from 'axios';
import { loadingData } from './basic.actions';

export function handleGetTenantLicenseData(): DispatchFunction {
    return ((dispatch: Dispatch) => {
        dispatch(licensesLoading(true));
        licenseAllocationService.getTenantLicense()
            .then((response: AxiosResponse) => {
                dispatch(getTenantLicense(response.data));
                dispatch(licensesLoading(false));
            });
    });
}

export function handleGetOrgLicenseData(orderBy: string, asc: string, top: number, skip: number, count: boolean, filters?: IActiveFilter[]): DispatchFunction {
    return ((dispatch: Dispatch) => {
        if (count) {
            dispatch(loadingData(true));
            dispatch(setOrgLicenseCount(0));
            dispatch(getOrgLicenses([]));
        }
        licenseAllocationService.getOrgLicenses(orderBy, asc, top, skip, count, filters)
            .then((response: AxiosResponse) => {
                if (count) {
                    dispatch(setOrgLicenseCount(response.data['@odata.count']));
                }

                dispatch(getOrgLicenses(response.data.value));
                dispatch(loadingData(false));
            });
    });
}

export function getTenantLicense(tenantLicense: ITenantLicense) {
    return {
        payload: tenantLicense,
        type: GET_TENANT_LICENSE
    };
}

export function getOrgLicenses(orgLicenses: IOrganizationLicenseInfo[]) {
    return {
        payload: orgLicenses,
        type: GET_ORG_LICENSES
    };
}

export function licensesLoading(loading: boolean) {
    return {
        payload: loading,
        type: LICENSES_LOADING
    };
}

export function setOrgLicenseCount(count: number) {
    return {
        payload: count,
        type: ORG_LICENSE_COUNT
    };
}